/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseOrganizationConfig
 */
export interface GetConfig200ResponseOrganizationConfig {
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    barcodes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    showManualShipment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    waitForNumberBeforePrintingBill?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    seatSelector?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    seatsRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    ratings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    restaurantAutoprint?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseOrganizationConfig
     */
    takeawayAutoprint?: boolean;
}

/**
 * Check if a given object implements the GetConfig200ResponseOrganizationConfig interface.
 */
export function instanceOfGetConfig200ResponseOrganizationConfig(value: object): value is GetConfig200ResponseOrganizationConfig {
    return true;
}

export function GetConfig200ResponseOrganizationConfigFromJSON(json: any): GetConfig200ResponseOrganizationConfig {
    return GetConfig200ResponseOrganizationConfigFromJSONTyped(json, false);
}

export function GetConfig200ResponseOrganizationConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseOrganizationConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'barcodes': json['barcodes'] == null ? undefined : json['barcodes'],
        'showManualShipment': json['showManualShipment'] == null ? undefined : json['showManualShipment'],
        'waitForNumberBeforePrintingBill': json['waitForNumberBeforePrintingBill'] == null ? undefined : json['waitForNumberBeforePrintingBill'],
        'seatSelector': json['seatSelector'] == null ? undefined : json['seatSelector'],
        'seatsRequired': json['seatsRequired'] == null ? undefined : json['seatsRequired'],
        'ratings': json['ratings'] == null ? undefined : json['ratings'],
        'restaurantAutoprint': json['restaurantAutoprint'] == null ? undefined : json['restaurantAutoprint'],
        'takeawayAutoprint': json['takeawayAutoprint'] == null ? undefined : json['takeawayAutoprint'],
    };
}

export function GetConfig200ResponseOrganizationConfigToJSON(json: any): GetConfig200ResponseOrganizationConfig {
    return GetConfig200ResponseOrganizationConfigToJSONTyped(json, false);
}

export function GetConfig200ResponseOrganizationConfigToJSONTyped(value?: GetConfig200ResponseOrganizationConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'barcodes': value['barcodes'],
        'showManualShipment': value['showManualShipment'],
        'waitForNumberBeforePrintingBill': value['waitForNumberBeforePrintingBill'],
        'seatSelector': value['seatSelector'],
        'seatsRequired': value['seatsRequired'],
        'ratings': value['ratings'],
        'restaurantAutoprint': value['restaurantAutoprint'],
        'takeawayAutoprint': value['takeawayAutoprint'],
    };
}

